import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withLastLocation} from 'react-router-last-location';
// PrimeReact components
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {ScrollPanel} from 'primereact/scrollpanel';

// Styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './not-authorized.scss';

class manageShelfList extends Component {
    state = {
        shelves: null,
        deleteDialogVisible: false,
        // Added another key to the component state to manage cases when we can't delete for any reason.
        // This key is connected to the delete button on the DeleteDialog component to prevent clicks.
        unableToDelete: false,
        // Created a key for Shelves that were selected and feature a launch id.
        selectedShelvesWithLaunchIds: [],
    };

    onClickDeleteShelves = () => {
        const {selectedShelves} = this.state;

        // This searches for launch IDs. Looking for LaunchIds on this call is more efficient than doing it on table selection.
        const shelvesWithLaunchId = selectedShelves.filter(({ShelfDTO}) => !!ShelfDTO.launchId);
        this.setState({
            deleteDialogVisible: true,
            unableToDelete: shelvesWithLaunchId.length > 0,
            selectedShelvesWithLaunchIds: shelvesWithLaunchId,
        });
    };

    onClickBackToShelves = event => {
        const {lastLocation} = this.props;

        event.preventDefault();
        if (lastLocation) {
            window.location.href = lastLocation.pathname;
        } else {
            window.location.href = '/';
        }
    };

    onHide = () => {
        this.setState({deleteDialogVisible: false});
    };

    handleDelete = event => {
        const {deleteShelves} = this.props;
        const {selectedShelves} = this.state;

        event.preventDefault();
        this.setState({deleteDialogVisible: false});

        deleteShelves(selectedShelves);
    };

    render() {
        const {shelvesList} = this.props;
        const {shelves, selectedShelves, deleteDialogVisible, unableToDelete, selectedShelvesWithLaunchIds} = this.state;

        const footer = (
            <div>
                <Button
                    className="p-button-danger"
                    disabled={unableToDelete}
                    icon="pi pi-check"
                    label="DELETE"
                    onClick={this.handleDelete}
                />
                <Button icon="pi pi-times" label="No" onClick={this.onHide} />
            </div>
        );

        const showLaunchIdErrorMessage = () => (
            <ScrollPanel style={{width: '100%', height: '200px'}}>
                <h4 className="not-authorized">Can&apos;t delete selection</h4>
                {selectedShelvesWithLaunchIds.map(({ShelfDTO}) => (
                    <p>
                        Shelf <strong>{ShelfDTO.name}</strong> Contains a launch ID
                    </p>
                ))}
            </ScrollPanel>
        );

        if (!shelves) {
            this.setState({shelves: shelvesList});
        }

        if (shelvesList) {
            return (
                <div>
                    <Button
                        icon="pi pi-chevron-left"
                        label="Back"
                        style={{marginLeft: '2em'}}
                        onClick={event => {
                            this.onClickBackToShelves(event);
                        }}
                    />
                    <Button
                        icon="pi pi-trash"
                        label="Delete Shelves"
                        style={{marginLeft: '1em'}}
                        onClick={event => {
                            this.onClickDeleteShelves(event);
                        }}
                    />

                    <br />
                    <br />
                    <DataTable
                        selection={selectedShelves}
                        style={{marginLeft: '2em'}}
                        value={shelves}
                        onSelectionChange={e => this.setState({selectedShelves: e.value})}
                    >
                        <Column selectionMode="multiple" style={{width: '50px'}} />
                        <Column columnKey="ShelfDTO.name" field="ShelfDTO.name" header="Shelf Name" sortable={true} />
                        <Column
                            columnKey="ShelfDTO.homeScreenShelf"
                            field="ShelfDTO.homeScreenShelf"
                            header="Home Screen Shelf"
                        />
                    </DataTable>

                    <Dialog
                        dismissableMask={true}
                        footer={footer}
                        header="Delete Selected Shelves ?"
                        maximizable={true}
                        modal={true}
                        style={{width: '50vw'}}
                        visible={deleteDialogVisible}
                        onHide={this.onHide}
                    >
                        <br />
                        <br />
                        <ScrollPanel style={{width: '100%', height: '500px'}}>
                            <DataTable value={selectedShelves}>
                                <Column
                                    columnKey="ShelfDTO.name"
                                    field="ShelfDTO.name"
                                    header="DELETE the following shelves?"
                                />
                            </DataTable>
                        </ScrollPanel>
                        <br />
                        {selectedShelvesWithLaunchIds.length > 0 ? showLaunchIdErrorMessage() : null}
                    </Dialog>
                </div>
            );
        }
    }
}

manageShelfList.propTypes = {
    deleteShelves: PropTypes.func.isRequired,
    lastLocation: PropTypes.object.isRequired,
    shelvesList: PropTypes.array.isRequired,
};

export default withLastLocation(manageShelfList);
